import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {IAlternativeSecurity} from "@irb/irb-editors/irb-editors.model";

@Component({ standalone: false,
    selector: 'irb-inverse-account-type-dialog',
    templateUrl: './inverse-account-type-dialog.component.html',
    styleUrls: ['./inverse-account-type-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class InverseAccountTypeDialogComponent implements OnInit {
    selectedInverseAccountType: any;
    alternateSecurity: IAlternativeSecurity;
    inverseAccountTypeContinueFunction: Function;
    inverseAccountTypeCloseFunction: Function;

    constructor(public dialogRef: MatDialogRef<InverseAccountTypeDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public mdd: any) {
    }


    ngOnInit(): void {
        this.alternateSecurity = this.mdd.alternateSecurity as IAlternativeSecurity;
        this.inverseAccountTypeContinueFunction = this.mdd.inverseAccountTypeContinueFunction || null;
        this.inverseAccountTypeCloseFunction = this.mdd.inverseAccountTypeCloseFunction || null;
    }

    close() {
        if(this.inverseAccountTypeCloseFunction) {
            this.inverseAccountTypeCloseFunction();
        }
        this.dialogRef.close();
    }

    onContinue() {
        let alternateAccountType = {
            alternateSecurity: this.alternateSecurity,
            inverseAccountType: this.selectedInverseAccountType
        };
        this.inverseAccountTypeContinueFunction(alternateAccountType);
        this.dialogRef.close();
    }

}
